/* RESPONSIBLE TEAM: team-standalone */
import type AppService from 'embercom/services/app-service';
import Step from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';
import { buildValidations, validator } from 'ember-cp-validations';

const Validations = buildValidations({
  salesforceInAppMessagingApiIsConnectedForIntercomMessenger: [
    validator('salesforce-in-app-messaging-api-integration-is-valid', {
      dependentKeys: [
        'model.app',
        'model.app.isStandaloneApp',
        'model.app.standalone_platforms',
        'model.finStandaloneService.salesforcePlatform.salesforceInAppMessagingConfig',
      ],
      messageKey:
        'operator.workflows.visual-builder.handoff-to-salesforce-in-app-messaging.invalid-api-connection',
    }),
  ],
});

export default class HandoffToSalesforceInAppMessaging extends Step.extend(Validations) {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare appService: AppService;

  get app() {
    return this.appService.app;
  }

  get supportedChannels() {
    return SUPPORTED_CHANNELS.handoffToSalesforceInAppMessaging;
  }

  static get supportedContexts() {
    return [TargetContext.Conversation];
  }

  static get isStepGroupEnding() {
    return true;
  }

  static get isStepTerminal() {
    return true;
  }

  static createNewStep(store: Store): HandoffToSalesforceInAppMessaging {
    return store.createRecord(
      'operator/visual-builder/step/handoff-to-salesforce-in-app-messaging',
      {
        type: 'operator/visual-builder/step/handoff-to-salesforce-in-app-messaging',
      },
    );
  }
}
